import Vue from 'vue';
import 'babel-polyfill';
import '@/assets/css/common.less';
import axios from 'axios';
import VueAxios from 'vue-axios';
import Qs from 'qs';

import router from './router';
import store from './store';
import App from './App';
import loading from './utils/loading.js'; // 引入loading

// ElementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { Message } from 'element-ui';
Vue.use(ElementUI);

// 打印工具
import Print from 'vue-print-nb';
Vue.use(Print);

// 富文本编辑器
import VueQuillEditor from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
Vue.use(VueQuillEditor);

// markdown 样式
import 'github-markdown-css/github-markdown.css';

// echarts
import echarts from 'echarts';
import 'echarts-wordcloud/dist/echarts-wordcloud';
import { userInfoApi } from '@/api/login';
Vue.prototype.$echarts = echarts;
Vue.use(echarts);

Vue.config.productionTip = false; // 阻止启动生产消息
Vue.prototype.$qs = Qs;
Vue.use(VueAxios, axios);
Vue.use(loading); // 全局使用loading

// 白名单: 登录、注册、404
const whiteList = [
  '404',
  'login',
  'registerApplication',
  'notAccess',
];
router.beforeEach((to, from, next) => {
  // 路由切换时取消所有pending请求
  if (Vue.prototype.$cancelAllRequests) {
    Vue.prototype.$cancelAllRequests('路由切换取消请求');
  }

  // 是否存在路由
  const routeExists = router.getRoutes().some((item) => item.name === to.name);
  if (!routeExists) {
    next({
      path: '/404',
      replace: true,
    });
    return;
  }

  let Token = localStorage.getItem('at_token');
  let AppName = process.env.VUE_APP_NAME;

  // 不在白名单且没有Token时跳转到登录页
  if (!whiteList.includes(to.name) && (!Token || Token === 'undefined') ) {
    if (AppName !== 'guojiao') {
      Message.warning('请登录后访问系统');
    }

    if (AppName === 'guojiao') {
      // 国交 token
      let GJToken = '5c169e72108b4e56b3d311e8efe9dd53';
      store.commit('SET_TOKEN', { token: GJToken });
      // 专家列表、专家详情、论文详情token
      localStorage.setItem(
        'TalentToken',
        '495aae05-f4eb-ff0c-27d6-c3be75cc8926'
      );

      userInfoApi(GJToken).then(res => {
        const { username, userId, nickname, org } = res.data;
        store.commit('SET_UserDetails', {
          userName: username,
          id: userId,
          nickName: nickname,
          org: org,
        });

        if (router.getRoutes().some(item => item.path === to.path)) {
          next({
            path: to.path,
            replace: true,
          });
        } else {
          // 如果路由不存在，跳转到 国交首页
          next({ name: 'resultsAnalysisGuoJiao', replace: true });
        }
      })
    } else {
      // 科技成果转化
      next({
        name: 'login',
        // 将跳转的路由path作为参数，登录成功后跳转到该路由
        // query: { redirect: to.fullPath },
        replace: true,
      });
    }
    return;
  }

  // 访问权限控制：科技成果转化
  if (AppName !== 'guojiao' && !whiteList.includes(to.name)) {
    try {
      // 解析数据
      const rawTags = localStorage.getItem('at_tags');

      // 获取所有禁止访问列表
      let forbiddenRouteNames = [];

      // 处理权限标签
      if (rawTags) {
        const tags = JSON.parse(rawTags);
        if (Array.isArray(tags)) {
          forbiddenRouteNames = tags
            .filter(tag => tag.authorization != 1)
            .map(tag => tag.name);
        }
      }

      // 权限检查，重定向无权限页面
      if (forbiddenRouteNames.includes(to.name)) {
        next({
          name: 'notAccess',
          replace: true,
        });
        return;
      }

    } catch (error) {
      console.error('解析权限出错:', error);
      next({
        name: 'notAccess',
        replace: true,
      });
      return;
    }
  }

  next();
});

const vue = new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount('#app');

export default vue;
